// extracted by mini-css-extract-plugin
module.exports = {"box":"mail_box__3adsZ","box_theme_light":"mail_box_theme_light__25edh","box_theme_dark":"mail_box_theme_dark__3xLjh"};